export default __webpack_public_path__ + "static/ios-header-b954eb5ba53d625a106cd4bdaa249579.jpg";